//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminObligationFileController_updateOneById,
  Response$AdminObligationFileController_updateOneById$Status$200,
  ResponseContentType$AdminObligationFileController_updateOneById,
} from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useAdminObligationFileController_updateOneById = () =>
  useApiClientMutation<
    Params$AdminObligationFileController_updateOneById,
    Response$AdminObligationFileController_updateOneById$Status$200[ResponseContentType$AdminObligationFileController_updateOneById]
  >({ method: 'AdminObligationFileController_updateOneById' });
